import React from "react";

// Etichette leggibili per le sei colonne che identificano un "materiale
// duplicato esatto" — vedi Revisione.jsx, CHIAVI_DUPLICATO.
const ETICHETTE = {
  codice_materiale: "Codice Materiale",
  descrizione_materiale: "Descrizione Materiale",
  codice_colore: "Codice Colore",
  descrizione_colore: "Descrizione Colore",
  um: "UM",
  consumo: "Consumo",
};

// Popup "🧩 Righe duplicate" (vedi Revisione.jsx, icona 🧩⚠️
// nell'intestazione e avviso prima dello scarica()): un materiale ripetuto
// più volte con Codice Materiale, Descrizione, Colore, UM e Consumo TUTTI
// identici — non è per forza un errore (può capitare con un consumo
// diverso per una parte diversa del prodotto finito, ma qui il consumo è
// proprio lo stesso), quindi non si blocca l'export: si mostra il gruppo e
// si lascia scegliere se eliminare le righe in più, riga per riga o tutte
// insieme.
export default function DuplicatiModal({ gruppi, righe, onElimina, onChiudi }) {
  const totaleRighe = gruppi.reduce((tot, g) => tot + g.indici.length, 0);

  function eliminaRiga(i) {
    onElimina([i]);
  }

  function eliminaGruppo(g) {
    if (!window.confirm(`Eliminare tutte le ${g.indici.length} righe di questo gruppo? Non si può annullare.`)) return;
    onElimina(g.indici);
  }

  function eliminaTutti() {
    if (!window.confirm(`Eliminare tutte le ${totaleRighe} righe duplicate (${gruppi.length} gruppi)? Non si può annullare.`)) return;
    onElimina(gruppi.flatMap((g) => g.indici));
  }

  // "Mantieni solo una" per TUTTI i gruppi insieme: tiene la prima riga di
  // ogni gruppo (i valori sono comunque identici tra loro, non importa
  // quale) ed elimina il resto — il modo più veloce per ripulire un file
  // dove i duplicati sono chiaramente un errore, senza doverli eliminare uno
  // per uno o gruppo per gruppo.
  const totaleDaEliminareTenendoUna = totaleRighe - gruppi.length;
  function mantieniSoloUna() {
    const daEliminare = gruppi.flatMap((g) => g.indici.slice(1));
    if (daEliminare.length === 0) return;
    if (!window.confirm(`Tenere solo una riga per ciascuno dei ${gruppi.length} materiali duplicati ed eliminare le altre ${daEliminare.length} righe? Non si può annullare.`)) return;
    onElimina(daEliminare);
  }

  return (
    <div
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: "Inter, sans-serif" }}
      onClick={onChiudi}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "var(--cf-bg-card)", borderRadius: "16px", width: "720px", maxWidth: "94vw", maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.45)" }}
      >
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #7f1d1d 100%)", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "20px", lineHeight: 1 }}>🧩⚠️</span>
            <div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontWeight: 700, fontSize: "15px", letterSpacing: "1px", textTransform: "uppercase", color: "#f1f5f9" }}>
                Righe duplicate
              </div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontSize: "11px", color: "var(--cf-text-faint)", letterSpacing: "0.3px", marginTop: "3px" }}>
                Stesso Codice Materiale, Descrizione, Colore, UM e Consumo
              </div>
            </div>
          </div>
          <button className="cf-btn" onClick={onChiudi} style={{ border: "none", background: "rgba(255,255,255,0.08)", borderRadius: "6px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", color: "#cbd5e1", lineHeight: 1 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "24px", overflowY: "auto" }}>
          {gruppi.length === 0 ? (
            <p className="testo-secondario" style={{ marginTop: 0 }}>
              ✅ Nessuna riga duplicata rimasta.
            </p>
          ) : (
            <>
              <p className="testo-secondario" style={{ marginTop: 0 }}>
                Un materiale che si ripete non è per forza un errore — può avere un consumo diverso per una parte
                diversa del prodotto finito. Qui sono elencate solo le righe identiche su tutte e sei le colonne
                insieme: controllale e, se sono davvero un errore, eliminale singolarmente o tutte insieme.
              </p>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: "8px", marginBottom: "16px" }}>
                <span className="testo-secondario">
                  {gruppi.length} gruppi, {totaleRighe} righe totali
                </span>
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  <button
                    onClick={mantieniSoloUna}
                    title={`Tiene la prima riga di ogni gruppo (i valori sono comunque identici) ed elimina le altre ${totaleDaEliminareTenendoUna} — il modo più veloce per ripulire tutto in un colpo solo`}
                  >
                    ✅ Mantieni solo una ({totaleDaEliminareTenendoUna} da eliminare)
                  </button>
                  <button
                    onClick={eliminaTutti}
                    style={{ backgroundColor: "#7f1d1d", color: "#fff", borderColor: "#7f1d1d" }}
                  >
                    🗑️ Elimina tutte le righe duplicate ({totaleRighe})
                  </button>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                {gruppi.map((g) => {
                  const primaRiga = righe[g.indici[0]] || {};
                  return (
                    <div
                      key={g.indici.join(",")}
                      style={{ padding: "12px 14px", borderRadius: "8px", backgroundColor: "var(--cf-bg-subtle)", border: "1px solid var(--cf-border)" }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: "8px", marginBottom: "8px" }}>
                        <div style={{ fontSize: "13px" }}>
                          {Object.entries(ETICHETTE).map(([chiave, etichetta], idx) => (
                            <span key={chiave}>
                              {idx > 0 && <span className="testo-secondario"> · </span>}
                              <span className="testo-secondario">{etichetta}: </span>
                              <strong style={{ fontFamily: "'Roboto Mono', Consolas, monospace" }}>{String(primaRiga[chiave] ?? "")}</strong>
                            </span>
                          ))}
                        </div>
                        <button onClick={() => eliminaGruppo(g)} title="Elimina tutte le righe di questo gruppo">
                          🗑️ Elimina le {g.indici.length} righe
                        </button>
                      </div>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                        {g.indici.map((i) => (
                          <span
                            key={i}
                            style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "3px 4px 3px 10px", borderRadius: "999px", backgroundColor: "var(--cf-bg-card)", border: "1px solid var(--cf-border)", fontSize: "12px" }}
                          >
                            riga {i + 1}
                            <button
                              className="btn-link"
                              onClick={() => eliminaRiga(i)}
                              title={`Elimina solo la riga ${i + 1}`}
                              style={{ color: "var(--cf-danger-text)" }}
                            >
                              ✕
                            </button>
                          </span>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

        <div style={{ padding: "16px 24px", borderTop: "1px solid var(--cf-border)", display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
          <button onClick={onChiudi}>Chiudi</button>
        </div>
      </div>
    </div>
  );
}
